import React, { useState, useEffect } from 'react';
import { Container, Badge } from "reactstrap";

import Tickets from "./openedTickets";
import ClosedTickets from "./closedTickets";
import CanceledTickets from "./canceledTickets";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useSelector } from "react-redux";

const TABS = [
    { id: "1", label: "Abiertos", icon: "directions_car" },
    { id: "2", label: "Cerrados", icon: "check_circle" },
    { id: "3", label: "Cancelados", icon: "block" },
];

const useIsMobile = (bp = 768) => {
    const [m, setM] = useState(window.innerWidth < bp);
    useEffect(() => { const h = () => setM(window.innerWidth < bp); window.addEventListener("resize", h); return () => window.removeEventListener("resize", h); }, [bp]);
    return m;
};

const TicketsPage = () => {
    document.title = "TicketControl - Tickets";
    const isMobile = useIsMobile();
    const [activeTab, setActiveTab] = useState("1");
    const openedTickets = useSelector((state) => state.data.openedTickets);
    const openCount = Array.isArray(openedTickets) ? openedTickets.length : 0;

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title="TicketControl" breadcrumbItem="Tickets" />

                {/* Pill tabs */}
                <div className="d-flex gap-2 mb-3 flex-wrap">
                    {TABS.map((tab) => {
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                className={`btn btn-sm ${isActive ? "btn-primary" : "btn-light"}`}
                                style={{ borderRadius: 20, padding: isMobile ? "4px 10px" : "5px 14px", fontSize: isMobile ? 12 : 14, fontWeight: isActive ? 600 : 400 }}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>{tab.icon}</span>
                                {tab.label}
                                {tab.id === "1" && openCount > 0 && (
                                    <Badge
                                        pill
                                        color={isActive ? "light" : "primary"}
                                        className={`ms-1 ${isActive ? "text-primary" : ""}`}
                                        style={{ fontSize: 11 }}
                                    >
                                        {openCount}
                                    </Badge>
                                )}
                            </button>
                        );
                    })}
                </div>

                {/* Content */}
                <div>
                    {activeTab === "1" && <Tickets />}
                    {activeTab === "2" && <ClosedTickets />}
                    {activeTab === "3" && <CanceledTickets />}
                </div>
            </Container>
        </div>
    );
}

export default TicketsPage;
